var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teams-list"},[_c('div',{staticClass:"teams-list__heading"},[_vm._v(" Your teams ")]),_vm._l((_vm.teams),function(team,i){return _c('TeamItem',{key:i,attrs:{"team":team}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }